import React, { useCallback, useEffect, useRef, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { blogList, bookMarkCourse, categoryList, contactUs, courseListing, homeCount, homeCourseListing } from '../../api/apiHandler';
import { Loading } from '../../components/loading/loading';
import { formatDuration, isValidImageUrl } from '../../common/utilityFunctions';
import { useSelector } from 'react-redux';
import { encryption } from '../../common/enc_dec';
import { showErrorMessage, showPromiseNotification } from '../../common/notification';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import moment from 'moment/moment';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import * as Yup from "yup";
import Select from 'react-select';
import { reactSelectStyles } from '../../common/customCss';
import ReactPaginate from "react-paginate";
import { useTranslation } from 'react-i18next';
import '../../i18';
import { validateNoStartOrEndSpace } from '../../cutomValidationField';

const Home = () => {
    const { t, i18n } = useTranslation();
    const location = useLocation();
    const navigate = useNavigate();
    const courseSectionRef = useRef(null);
    const isLoggedIn = useSelector((state) => state.auth.userToken);
    const userInfo = useSelector((state) => state.auth.userInfo);
    const lang = useSelector((state) => state.auth.language);

    const [courseList, setCourseList] = useState([]);
    const [hasMounted, setHasMounted] = useState(false);
    const [blogs, setBlogs] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [categories, setCategories] = useState([]);
    const [selectedCategoryId, setSelectedCategoryId] = useState(null);
    const [countData, setCountData] = useState({});

    const [hoveredRating, setHoveredRating] = useState(0); // Temporary hover rating
    const [selectedRating, setSelectedRating] = useState(0); // Permanent selected rating
    let debounceTimer = null;

    const minRange = 0;
    const maxRange = 25000;

    const [range1, setRange1] = useState(minRange);
    const [range2, setRange2] = useState(maxRange);
    const [totalPage, setTotalPage] = useState('');

    useEffect(() => {
        i18n.changeLanguage(userInfo?.lang_code);
    }, [])

    useEffect(() => {
        if (location.state?.selectedCategoryId) {
            setSelectedCategoryId(location.state.selectedCategoryId);

            // Optionally fetch courses for the selected category
            setListingParams((prev) => ({
                ...prev,
                category_id: location.state.selectedCategoryId,
            }));
            setTimeout(() => {
                courseSectionRef.current?.scrollIntoView({ behavior: 'smooth' });
                navigate(location.pathname, { replace: true });
            }, 500);
        }
    }, [location.state, location.pathname, navigate]);

    // const lang = getLocalStorageItem("language")
    // console.log('lang: ', lang)

    useEffect(() => {
        setListingParams((prev) => ({
            ...prev,
            language: lang?.name || 'english'
        }))
    }, [lang])

    const [listingParams, setListingParams] = useState({
        language: 'english',
        sort: null,
        category_id: null,
        min_price: minRange,
        max_price: maxRange,
        min_review: 0,
        max_review: 5,
        limit: 6
    });

    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
    };

    const teamSettings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 0,
                settings: {
                    slidesToShow: 1,
                }
            },
            {
                breakpoint: 760,
                settings: {
                    slidesToShow: 1,
                }
            },
            {
                breakpoint: 1000,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 1320,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 1400,
                settings: {
                    slidesToShow: 3,
                }
            },
        ]
    };

    const homeCountResponse = async () => {
        const response = await homeCount();
        if (response?.code === 200) {
            setCountData(response?.data)
        }
    }

    useEffect(() => {
        const fetchData = async () => {
            try {
                if (!hasMounted) setIsLoading(true);

                const apiCall = isLoggedIn ? courseListing : homeCourseListing;
                const response = await apiCall({ ...listingParams });

                if (response.code === 200 || response.code === 404) {
                    let courses = response.data.data;
                    setCourseList(courses);
                    setTotalPage(response.data.paging)
                }
            } catch (err) {
                console.log(err, "error found");
            } finally {
                if (!hasMounted) setIsLoading(false);
                setHasMounted(true);
            }
        };

        fetchData();
    },
        [listingParams]
    );

    useEffect(() => {
        const fetchBlogs = async () => {
            try {
                const response = await blogList({
                    limit: 3
                });
                if (response.code === 200 || response.code === 404) {
                    setBlogs(response.data);
                }
            }
            catch (err) {
                console.log('err: ', err);
            }
        }
        fetchBlogs();
    }, [])

    useEffect(() => {
        homeCountResponse();
    }, [])

    useEffect(() => {
        categoryList({
            limit: Number.MAX_SAFE_INTEGER
        })
            .then(response => {
                if (response.code === 200) {
                    setCategories(response.data.data);
                }
                else {
                    setCategories([]);
                }
            })
    }, [])

    const handleBookmark = async (courseId) => {
        if (!isLoggedIn) {
            return showErrorMessage(t("loginToAddFav"));
        }

        // Prevent double-click by clearing previous timer
        if (debounceTimer) {
            clearTimeout(debounceTimer);
        }

        // Set a new debounce timer
        debounceTimer = setTimeout(async () => {
            const myPromise = new Promise(async (resolve, reject) => {
                const response = await bookMarkCourse({ course_id: courseId });
                if (response?.code === 200) {
                    const isFavorite = response.message === t('addedInFav');
                    setCourseList((prevCourses) =>
                        prevCourses.map(course =>
                            course.id === courseId ? { ...course, user_favorite_course: [{ is_favorite: isFavorite }] } : course
                        )
                    );
                    resolve(response);
                } else {
                    reject(response);
                }
            });
            showPromiseNotification(myPromise);
        }, 300); // 300ms delay before executing the function
    };

    const contactUsSchema = Yup.object().shape({
        first_name: Yup.string()
            .trim()
            .required(t('required', { field: t("first_name") }))
            .test('no-start-or-end-space', t('noStartEndSpace', { field: t("First_Name") }), validateNoStartOrEndSpace)
            .min(2, t('min', { field: t("First_Name"), value: 2 }))
            .max(50, t('max', { field: t("First_Name"), value: 50 })),

        last_name: Yup.string()
            .trim()
            .required(t('required', { field: t("last_name") }))
            .test('no-start-or-end-space', t('noStartEndSpace', { field: t("Last_Name") }), validateNoStartOrEndSpace)
            .min(2, t('min', { field: t("Last_Name"), value: 2 }))
            .max(50, t('max', { field: t("Last_Name"), value: 50 })),

        email: Yup.string()
            .email(t('valid', { field: t("email") }))
            .required(t('required', { field: t("email") })),

        subject: Yup.string()
            .required(t('required', { field: t("subject") }))
            .min(3, t('min', { field: t("Subject"), value: 3 }))
            .max(100, t('max', { field: t("Subject"), value: 100 })),

        description: Yup.string()
            .required(t('required', { field: t("message") }))
            .test('no-start-or-end-space', t('noStartEndSpace', { field: t("Message") }), validateNoStartOrEndSpace)
            .min(10, t('min', { field: t("Message"), value: 10 }))
            .max(1000, t('max', { field: t("Message"), value: 1000 })),
    });

    const contactFormOptions = { resolver: yupResolver(contactUsSchema) };
    const { register, handleSubmit, formState, reset } = useForm(contactFormOptions);
    const { errors } = formState;

    const onSubmit = useCallback(
        async (values) => {
            const myPromise = new Promise(async (resolve, reject) => {
                const response = await contactUs(values)
                if (response.code == 200) {
                    resolve(response);
                } else {
                    reject(response);
                }
                reset();
            });
            showPromiseNotification(myPromise);
        }
    )

    const handleCloseFilter = () => {
        setSelectedCategoryId(null);
        setListingParams({
            ...listingParams,
            category_id: null
        });
    }

    const handleApplyFilter = () => {
        setListingParams({
            ...listingParams,
            category_id: selectedCategoryId
        });
    }

    const handleApplySortBy = () => {
        let isLatest = document.getElementById('sortby-latest-inp');
        setListingParams({
            ...listingParams,
            min_price: range1,
            max_price: range2,
            min_review: selectedRating,
            max_review: 5,
            sort: isLatest.checked ? 'id:desc' : null
        });
    }

    const handleCloseSortBy = () => {
        let isLatest = document.getElementById('sortby-latest-inp');
        isLatest.checked = false;
        setRange1(minRange);
        setRange2(maxRange);
        setSelectedRating(0);
        setListingParams({
            ...listingParams,
            min_price: minRange,
            max_price: maxRange,
            min_review: 0,
            max_review: 5,
            sort: null
        });
    }

    const handleRange1Input = (e) => {
        const value = Math.min(parseInt(e.target.value), range2 - 1);
        setRange1(value);
    };

    const handleRange2Input = (e) => {
        const value = Math.max(parseInt(e.target.value), range1 + 1);
        setRange2(value);
    };

    const handleMouseLeave = () => {
        setHoveredRating(0);
    };

    const handleRatingClick = (index, isHalf) => {
        setSelectedRating(index + (isHalf ? 0.5 : 1));
    };

    const renderStarIcon = (index) => {
        const rating = hoveredRating || selectedRating;

        if (index + 1 <= rating) {
            return `${process.env.PUBLIC_URL}/assets/img/icon/fullstar.svg`;
        } else if (index + 0.5 === rating) {
            return `${process.env.PUBLIC_URL}/assets/img/icon/halfstar.svg`;
        } else {
            return `${process.env.PUBLIC_URL}/assets/img/icon/emptystar.svg`;
        }
    };

    const handleMouseMove = (index, event) => {
        const isHalf = event.nativeEvent.offsetX < event.target.clientWidth / 2;
        setHoveredRating(index + (isHalf ? 0.5 : 1));
    };

    const handlePageClick = (e) => {
        setListingParams({
            ...listingParams,
            page: e.selected + 1
        });
    }

    if (isLoading) {
        return (
            <Loading />
        )
    }

    return (
        <>
            {/* banner start */}
            <div className="banner-area banner-area-1 bg-gray">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-5 col-md-8 order-lg-12 align-self-center">
                            <div className="thumb b-animate-thumb">
                                <img src={process.env.PUBLIC_URL + "/assets/img/banner/banner.png"} alt="img" />
                            </div>
                        </div>
                        <div className="col-lg-7 order-lg-1 align-self-center">
                            <div className="banner-inner text-center text-lg-left mt-5 mt-lg-0">
                                <h6 className="b-animate-1 sub-title">{t('headingTitle')}</h6>
                                <h1 className="b-animate-2 title">
                                    {t('headingDescription')}
                                </h1>
                                <a className="btn btn-base b-animate-3 mr-sm-3 mr-2" href="#abc">
                                    {t('headingButton')}
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* banner end */}
            {/* intro area start */}
            <div className="intro-area intro-area--top">
                <div className="container">
                    <div className="intro-area-inner bg-black">
                        <div className="row no-gutters">
                            <div className="col-lg-4 text-lg-left text-center">
                                <div className="intro-title">
                                    <h3>{t('leftHeading')}</h3>
                                    {/* <p>{t('leftHeadingContent')}</p> */}
                                    {/* <ul>
                                        <li>
                                            <i className="fa fa-check" /> Nullam est{" "}
                                        </li>
                                        <li>
                                            <i className="fa fa-check" /> Mattis dictum nunc{" "}
                                        </li>
                                    </ul> */}
                                </div>
                            </div>
                            <div className="col-lg-8 align-self-center">
                                <ul className="row no-gutters">
                                    <li className="col-md-4">
                                        <div className="single-intro-inner style-white text-center">
                                            <div className="thumb">
                                                <div className="IconEightZero">
                                                    <img
                                                        src={process.env.PUBLIC_URL + "/assets/img/icon/iconeightZero1.svg"}
                                                        alt="img"
                                                    />
                                                </div>
                                            </div>
                                            <div className="details">
                                                <h5>{t('firstIconHeading')}</h5>
                                                {/* <p>{t('firstIcon')}</p> */}
                                            </div>
                                        </div>
                                    </li>
                                    <li className="col-md-4">
                                        <div className="single-intro-inner style-white text-center">
                                            <div className="thumb">
                                                <div className="IconEightZero">
                                                    <img
                                                        src={process.env.PUBLIC_URL + "/assets/img/icon/iconeightZero2.svg"}
                                                        alt="img"
                                                    />
                                                </div>
                                            </div>
                                            <div className="details">
                                                <h5>{t('secondIconHeading')}</h5>
                                                {/* <p>{t('secondIcon')}</p> */}
                                            </div>
                                        </div>
                                    </li>
                                    <li className="col-md-4">
                                        <div className="single-intro-inner style-white text-center">
                                            <div className="thumb">
                                                <div className="IconEightZero">
                                                    <img
                                                        src={process.env.PUBLIC_URL + "/assets/img/icon/iconeightZero3.svg"}
                                                        alt="img"
                                                    />
                                                </div>
                                            </div>
                                            <div className="details">
                                                <h5>{t('thirdIconHeading')}</h5>
                                                {/* <p>{t('thirdIcon')}</p> */}
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* intro area end */}
            {/* about area start */}
            <div className="about-area pd-top-140" id='about-us'>
                <div className="container">
                    <div className="about-area-inner">
                        <div className="row">
                            <div className="col-lg-6">
                                <div
                                    className="about-thumb-wrap left-icon"
                                    style={{ backgroundImage: `url("${process.env.PUBLIC_URL}/assets/img/banner/banner2.png")` }}
                                >
                                    <div className="about-icon">
                                        <img src={process.env.PUBLIC_URL + "/assets/img/icon/41.svg"} alt="img" />
                                    </div>
                                    {/* <div className="bottom-content">
                                        {t('aboutUsHomeBottomContent')}
                                    </div> */}
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="about-inner-wrap pl-xl-4 pt-5 pt-lg-0 mt-5 mt-lg-0">
                                    <div className="section-title mb-0">
                                        <h6 className="sub-title right-line">{t('aboutUsHome')}</h6>
                                        <h3 className="title">Empowering Law Enforcement Professionals</h3>
                                        <p className="content mt-0">
                                            At LEA.Training, we are dedicated to advancing the skills and knowledge of law enforcement professionals across the globe. Our mission is to equip officers, detectives, and security personnel with the latest in cutting-edge training, technology, and tactical expertise to enhance public safety and security.
                                        </p>
                                        <h3 className="title mt-3">Our Vision</h3>
                                        <p className="content mt-0">
                                            Our vision is to become the leading provider of comprehensive law enforcement training solutions, fostering a safer world through education and empowerment. We aim to bridge the gap between traditional methods and modern demands, preparing law enforcement agencies to face today’s challenges with confidence and efficiency.
                                        </p>
                                        <p className='content fw-bold'><Link to="/about-us">Read More...</Link></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* about area end */}
            {/* course area start */}
            <div ref={courseSectionRef} className="course-area pd-top-100 pd-bottom-90" id='top-featured-courses'>
                <div className="container">
                    <div className="row">
                        <div className="col-12 ">
                            <div className="section-title style-white">
                                <div className="TopFeaturedMainBox">
                                    <h2 className="title" id='courses'>{t('featuredCoursesHeading')}</h2>
                                    <ul className="SortFilterUl">
                                        <li className="SortFilterLi">
                                            <div className="SortFilterDropdow">
                                                <a href="javascript:void(0)" className="SortFilterDropLink p-3 text-center" data-bs-toggle="offcanvas" data-bs-target="#sorting_canvas">
                                                    {t('sort')}
                                                </a>
                                            </div>
                                        </li>
                                        <li className="SortFilterLiDrop">
                                            <div className="SortFilterDropdow">
                                                <a
                                                    href="javascript:void(0)"
                                                    className="SortFilterDropLink p-3 text-center"
                                                    data-bs-toggle="offcanvas"
                                                    data-bs-target="#FilterByOffcanvas"
                                                >
                                                    {t('filter')}
                                                </a>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-12">
                            <div className="row">
                                {courseList.length > 0 &&
                                    courseList?.map((course) => (
                                        <div className="col-lg-4 col-md-6 CourseGride" key={course?.id}>
                                            <div className="single-course-inner">
                                                <Link
                                                    to={
                                                        isLoggedIn
                                                            ? course?.is_purchage
                                                                ? course?.user_course?.[0]?.is_test_completed === false && course?.is_expired === false
                                                                    ? `/start-course/${encodeURIComponent(
                                                                        encryption(
                                                                            {
                                                                                course_id: course.id,
                                                                                category_id: course.category_id,
                                                                                language: course.language,
                                                                                is_completed: course?.user_course?.[0]?.is_completed,
                                                                            },
                                                                            true
                                                                        )
                                                                    )}`
                                                                    : '/course'
                                                                : `/course-details/${encodeURIComponent(
                                                                    encryption(
                                                                        {
                                                                            id: course?.id,
                                                                            category_id: course?.category_id,
                                                                            language: course?.language,
                                                                        },
                                                                        true
                                                                    )
                                                                )}`
                                                            : "/sign-in"
                                                    }
                                                    state={
                                                        course?.is_purchage && course?.user_course?.[0]?.is_test_completed
                                                            ? { tab: 'completed' }
                                                            : undefined}
                                                    className="thumb"
                                                    onClick={() => {
                                                        if (!isLoggedIn) showErrorMessage("Please log in to view course details.");
                                                    }}
                                                >
                                                    <img
                                                        src={
                                                            isValidImageUrl(course.image)
                                                                ? course.image
                                                                : `${process.env.PUBLIC_URL}/assets/img/other/course.jpg`
                                                        }
                                                        alt={course?.name}
                                                    />
                                                </Link>
                                                <div className="details">
                                                    <Link to={isLoggedIn ?
                                                        course?.is_purchage ?
                                                            course?.user_course[0]?.is_test_completed === false && course?.is_expired === false ? `/start-course/${encodeURIComponent(encryption({
                                                                course_id: course.id,
                                                                category_id: course.category_id,
                                                                language: course.language,
                                                                is_completed: course.user_course[0].is_completed
                                                            }, true))}` : '/course' : `/course-details/${encodeURIComponent(encryption({
                                                                id: course?.id, category_id: course?.category_id, language: course?.language
                                                            }, true))}` : "/sign-in"} state={
                                                                course?.is_purchage && course?.user_course?.[0]?.is_test_completed
                                                                    ? { tab: 'completed' }
                                                                    : undefined} className="details-inner" onClick={() => { if (!isLoggedIn) showErrorMessage("Please log in to view course details.") }}>
                                                        <div className="d-flex justify-content-between mb-3">
                                                            <p className="CardMainHeading">{course?.course_category?.name}</p>
                                                            {
                                                                course?.assign_trainer && course?.assign_trainer.length > 0 &&
                                                                (
                                                                    <div className="emt-user">
                                                                        <span className="u-thumb">
                                                                            <img src={course?.assign_trainer[0]?.trainer_details?.image || process.env.PUBLIC_URL + '/assets/img/testimonial/review1.png'} alt="img" />
                                                                        </span>
                                                                        <span className="align-self-center">
                                                                            {course?.assign_trainer[0]?.trainer_details?.full_name}
                                                                        </span>
                                                                    </div>
                                                                )
                                                            }
                                                        </div>
                                                        <h6 className="CardMainSubHeading">
                                                            {course?.name}
                                                        </h6>
                                                        <div className="LassonsMain">
                                                            <ul className="LassonsUl">
                                                                <li className="LassonsLi">
                                                                    <p className="Lessonstext">{course?.total_lession} {t('lessons')}</p>
                                                                </li>
                                                                <li className="dots" />
                                                                <li className="LassonsLi">
                                                                    <p className="Lessonstext">{formatDuration(course?.duration, t)}</p>
                                                                </li>
                                                                <li className="dots" />
                                                                <li className="LassonsLi">
                                                                    <p className="Lessonstext">
                                                                        <strong>{course?.validity}</strong> {t('daysValidity')}
                                                                    </p>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </Link>
                                                    <div className="emt-course-meta">
                                                        <div className="LassonsCardFooter">
                                                            <ul className="LassonsCardFooterUl">
                                                                <li className="LassonsCardFooterLi">
                                                                    <div className="rating">
                                                                        <i className="fa fa-star" /> {course?.avg_review}
                                                                        <span>({course?.total_review})</span>
                                                                    </div>
                                                                </li>
                                                                <li className="LassonsCardFooterLi">
                                                                    <div className="price">
                                                                        <span>₹{course.price}</span>
                                                                    </div>
                                                                </li>
                                                                <li className="LassonsCardFooterLi">
                                                                    <div className="price" onClick={() => handleBookmark(course?.id)} style={{ cursor: "pointer" }}>
                                                                        {course?.user_favorite_course && course?.user_favorite_course?.length > 0 && course?.user_favorite_course[0]?.is_favorite ? (
                                                                            <i className="fa-solid fa-bookmark" />
                                                                        ) : (
                                                                            <i className="fa-regular fa-bookmark" />
                                                                        )}
                                                                    </div>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                }
                                {courseList.length === 0 &&
                                    <h4 className='text-center mt-3 fw-light'>{t('noCourseFound')}</h4>
                                }
                                {courseList && courseList.length > 0 && (
                                    <ReactPaginate
                                        className='pagination mt-4'
                                        breakLabel="..."
                                        nextLabel={`${t('next')} >`}
                                        previousLabel={`< ${t('Previous')} `}
                                        renderOnZeroPageCount={null}
                                        onPageChange={handlePageClick}
                                        pageCount={Math.ceil(totalPage.total / totalPage.page_limit)}
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* course area End */}
            {/* counter area start */}
            <div className="counter-area bg-gray">
                <div className="container">
                    <div
                        className="counter-area-inner pd-top-120 pd-bottom-120"
                        style={{ backgroundImage: `url("${process.env.PUBLIC_URL}/assets/img/other/1.png")` }}
                    >
                        <div className="row">
                            <div className="col-lg-8 mb-5 mb-lg-0">
                                <div className="section-title mb-0">
                                    {/* <h6 className="sub-title right-line">Funfact</h6> */}
                                    <h2 className="title ">{t('joinUs')}</h2>
                                    <p className="content pb-3">
                                        {t('joinUsDescription')}
                                    </p>
                                    <div className="btn-counter bg-base mt-4">
                                        <h3 className="left-val align-self-center">
                                            <span className="counter">{countData?.successfullStudents > 1000
                                                ? `${(countData.successfullStudents / 1000).toFixed(1)}k`
                                                : countData?.successfullStudents}</span>+
                                        </h3>
                                        <div className="right-val align-self-center">
                                            {t('successfulStudents')}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 align-self-center">
                                <ul className="single-list-wrap">
                                    <li className="single-list-inner style-box-bg">
                                        <div className="media">
                                            <div className="media-left">
                                                <img src={process.env.PUBLIC_URL + "/assets/img/icon/1.png"} alt="img" />
                                            </div>
                                            <div className="media-body align-self-center">
                                                <h5>
                                                    <span className="counter">{countData?.totalUsers > 1000
                                                        ? `${(countData?.totalUsers / 1000).toFixed(1)}k` : countData?.totalUsers}</span>+
                                                </h5>
                                                <p>{t('learnersAndCounting')}</p>
                                            </div>
                                        </div>
                                    </li>
                                    <li className="single-list-inner style-box-bg">
                                        <div className="media">
                                            <div className="media-left">
                                                <img src={process.env.PUBLIC_URL + "/assets/img/icon/2.png"} alt="img" />
                                            </div>
                                            <div className="media-body align-self-center">
                                                <h5>
                                                    <span className="counter">{countData?.totalCourses > 1000 ?
                                                        `${(countData?.totalCourses / 1000).toFixed(1)}k` : countData?.totalCourses}</span>+
                                                </h5>
                                                <p>{t('totalCourses')}</p>
                                            </div>
                                        </div>
                                    </li>
                                    <li className="single-list-inner style-box-bg">
                                        <div className="media">
                                            <div className="media-left">
                                                <img src={process.env.PUBLIC_URL + "/assets/img/icon/3.png"} alt="img" />
                                            </div>
                                            <div className="media-body align-self-center">
                                                <h5>
                                                    <span className="counter">{countData?.successfullStudents > 1000
                                                        ? `${(countData.successfullStudents / 1000).toFixed(1)}k`
                                                        : countData?.successfullStudents}</span>+
                                                </h5>
                                                <p>{t('successfulStudents')}</p>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* counter area end */}
            {/* work area start */}
            <div className="work-area pd-top-110" id='how-it-works'>
                <div className="container">
                    <div className="section-title">
                        <div className="row">
                            <div className="col-lg-6 align-self-center">
                                <h6 className="sub-title right-line">{t('whatWeDo')}</h6>
                                <h2 className="title">{t('howItWorksHome')}</h2>
                            </div>
                            <div className="col-lg-6 align-self-center">
                                <p className="content mt-lg-0">
                                    {t('howItWorksHomeDescription')}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-6 col-md-12">
                            <div className="single-intro-inner style-icon-bg bg-gray text-center">
                                <div className="thumb">
                                    <img src={process.env.PUBLIC_URL + "/assets/img/icon/12.png"} alt="img" />
                                    <div className="intro-count">1</div>
                                </div>
                                <div className="details">
                                    <h5>{t('signUpHome')}</h5>
                                    <h6>{t('signUpHomeTitle')}</h6>
                                    <p>
                                        {t('signUpHomeDescription')}
                                    </p>
                                    {/* <a className="read-more-text" href="signup.html">
                                        Read More <i className="fa fa-angle-right" />
                                    </a> */}
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-12">
                            <div className="single-intro-inner style-icon-bg bg-gray text-center">
                                <div className="thumb">
                                    <img src={process.env.PUBLIC_URL + "/assets/img/icon/13.png"} alt="img" />
                                    <div className="intro-count">2</div>
                                </div>
                                <div className="details">
                                    <h5>{t('selectCourseHome')}</h5>
                                    <h6>{t('selectCourseHomeTitle')}</h6>
                                    <p>
                                        {t('selectCourseHomeDescription')}
                                    </p>
                                    {/* <a className="read-more-text" href="course.html">
                                        Read More <i className="fa fa-angle-right" />
                                    </a> */}
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-12">
                            <div className="single-intro-inner style-icon-bg bg-gray text-center">
                                <div className="thumb">
                                    <img src={process.env.PUBLIC_URL + "/assets/img/icon/14.png"} alt="img" />
                                    <div className="intro-count">3</div>
                                </div>
                                <div className="details">
                                    <h5>{t('startLearningHome')}</h5>
                                    <h6>{t('startLearningHomeTitle')}</h6>
                                    <p>
                                        {t('startLearningHomeDescription')}
                                    </p>
                                    {/* <a className="read-more-text" href="course-details.php">
                                        Read More <i className="fa fa-angle-right" />
                                    </a> */}
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-12">
                            <div className="single-intro-inner style-icon-bg bg-gray text-center">
                                <div className="thumb">
                                    <img src={process.env.PUBLIC_URL + "/assets/img/icon/15.png"} alt="img" />
                                    <div className="intro-count">4</div>
                                </div>
                                <div className="details">
                                    <h5>{t('getCertificateHome')}</h5>
                                    <h6>{t('getCertificateHomeTitle')}</h6>
                                    <p>
                                        {t('getCertificateHomeDescription')}
                                    </p>
                                    {/* <a className="read-more-text" href="javascript:void(0)">
                                        Read More <i className="fa fa-angle-right" />
                                    </a> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* work area end */}
            {/* testimonial area start */}
            <div className="testimonial-area pd-top-100">
                <div className="container">
                    <div
                        className="testimonial-area-inner bg-cover"
                        style={{
                            backgroundImage: `url("${process.env.PUBLIC_URL}/assets/img/other/2.png")`
                        }}
                    >
                        <img
                            className="testimonial-right-img"
                            src={process.env.PUBLIC_URL + "/assets/img/other/3.png"}
                            alt="img"
                        />
                        <Slider {...settings} className="testimonial-slider">
                            <div className="item">
                                <div className="single-testimonial-inner style-white">
                                    <span className="testimonial-quote">
                                        <i className="fa fa-quote-left" />
                                    </span>
                                    <p className="mb-4">
                                        Eugene Freeman sit amet, consetetur sadipscing elitr, sed diam
                                        nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam
                                        erat, elitr, sed diam sed diam volu
                                    </p>
                                    <div className="media testimonial-author">
                                        <div className="media-left">
                                            <img
                                                src={process.env.PUBLIC_URL + "/assets/img/testimonial/2.png"}
                                                alt="img"
                                                className="img-cover"
                                            />
                                            <i className="fa fa-quote-left" />
                                        </div>
                                        <div className="media-body align-self-center">
                                            <h6>Eugene Freeman</h6>
                                            <p>Tincidunt</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="item">
                                <div className="single-testimonial-inner style-white">
                                    <span className="testimonial-quote">
                                        <i className="fa fa-quote-left" />
                                    </span>
                                    <p className="mb-4">
                                        Jaction Freeman amet, consetetur sadipscing elitr, sed diam
                                        nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam
                                        erat, sed elitr, sed diam diam volu
                                    </p>
                                    <div className="media testimonial-author">
                                        <div className="media-left">
                                            <img
                                                src={process.env.PUBLIC_URL + "/assets/img/testimonial/1.png"}
                                                alt="img"
                                                className="img-cover"
                                            />
                                            <i className="fa fa-quote-left" />
                                        </div>
                                        <div className="media-body align-self-center">
                                            <h6>Jaction Freeman</h6>
                                            <p>Tincidunt</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Slider>
                    </div>
                </div>
            </div>
            {/* testimonial area end */}
            {/* team area start */}
            <div className="team-area pd-top-110" id='our-creative-team'>
                <div className="container-fluid pl-4 pr-4">
                    <div className="row justify-content-center">
                        <div className="col-xl-6 col-lg-7">
                            <div className="section-title text-center">
                                <h6 className="sub-title double-line">{t('meetTeamHome')}</h6>
                                <h2 className="title">{t('teamHome')}</h2>
                            </div>
                        </div>
                    </div>
                    <Slider {...teamSettings} className="team-slider">
                        {/* Team Member 1 */}
                        <div className="item">
                            <div className="single-team-inner">
                                <div className="thumb">
                                    <img src={process.env.PUBLIC_URL + "/assets/img/team/team-image-1.png"} alt="Doris Jordan" />
                                    {/* <div className="social-wrap">
                                        <div className="social-wrap-inner">
                                            <a className="social-share" href="#">
                                                <i className="fa fa-share-alt" />
                                            </a>
                                            <ul>
                                                <li><a href="#"><i className="fa fa-facebook" /></a></li>
                                                <li><a href="#"><i className="fa fa-twitter" /></a></li>
                                                <li><a href="#"><i className="fa fa-pinterest" /></a></li>
                                                <li><a href="#"><i className="fa fa-linkedin" /></a></li>
                                            </ul>
                                        </div>
                                    </div> */}
                                </div>
                                <div className="details">
                                    <h4><a href="javascript:void(0)">{t('team1')}</a></h4>
                                    <span>{t('team1Description')}</span>
                                </div>
                            </div>
                        </div>

                        {/* Team Member 2 */}
                        <div className="item">
                            <div className="single-team-inner">
                                <div className="thumb">
                                    <img src={process.env.PUBLIC_URL + "/assets/img/team/team-image-2.png"} alt="Eugen Freman" />
                                    {/* <div className="social-wrap">
                                        <div className="social-wrap-inner">
                                            <a className="social-share" href="#">
                                                <i className="fa fa-share-alt" />
                                            </a>
                                            <ul>
                                                <li><a href="#"><i className="fa fa-facebook" /></a></li>
                                                <li><a href="#"><i className="fa fa-twitter" /></a></li>
                                                <li><a href="#"><i className="fa fa-pinterest" /></a></li>
                                                <li><a href="#"><i className="fa fa-linkedin" /></a></li>
                                            </ul>
                                        </div>
                                    </div> */}
                                </div>
                                <div className="details">
                                    <h4><a href="javascript:void(0)">{t('team2')}</a></h4>
                                    <span>{t('team2Description')}</span>
                                </div>
                            </div>
                        </div>

                        {/* Team Member 3 */}
                        <div className="item">
                            <div className="single-team-inner">
                                <div className="thumb">
                                    <img src={process.env.PUBLIC_URL + "/assets/img/team/team-image-3.png"} alt="Jaction Leo" />
                                    {/* <div className="social-wrap">
                                        <div className="social-wrap-inner">
                                            <a className="social-share" href="#">
                                                <i className="fa fa-share-alt" />
                                            </a>
                                            <ul>
                                                <li><a href="#"><i className="fa fa-facebook" /></a></li>
                                                <li><a href="#"><i className="fa fa-twitter" /></a></li>
                                                <li><a href="#"><i className="fa fa-pinterest" /></a></li>
                                                <li><a href="#"><i className="fa fa-linkedin" /></a></li>
                                            </ul>
                                        </div>
                                    </div> */}
                                </div>
                                <div className="details">
                                    <h4><a href="javascript:void(0)">{t('team3')}</a></h4>
                                    <span>{t('team3Description')}</span>
                                </div>
                            </div>
                        </div>

                        {/* Team Member 4 */}
                        {/* <div className="item team-card">
                            <div className="single-team-inner">
                                <div className="thumb">
                                    <img src={process.env.PUBLIC_URL + "/assets/img/testimonial/4.png"} alt="Jordan Feg" />
                                    <div className="social-wrap">
                                        <div className="social-wrap-inner">
                                            <a className="social-share" href="#">
                                                <i className="fa fa-share-alt" />
                                            </a>
                                            <ul>
                                                <li><a href="#"><i className="fa fa-facebook" /></a></li>
                                                <li><a href="#"><i className="fa fa-twitter" /></a></li>
                                                <li><a href="#"><i className="fa fa-pinterest" /></a></li>
                                                <li><a href="#"><i className="fa fa-linkedin" /></a></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="details">
                                    <h4><a href="#">Jordan Feg</a></h4>
                                    <span>Marketing Expert</span>
                                </div>
                            </div>
                        </div> */}

                        {/* Team Member 5 */}
                        {/* <div className="item team-card">
                            <div className="single-team-inner">
                                <div className="thumb">
                                    <img src={process.env.PUBLIC_URL + "/assets/img/testimonial/1.png"} alt="Walson Jordan" />
                                    <div className="social-wrap">
                                        <div className="social-wrap-inner">
                                            <a className="social-share" href="#">
                                                <i className="fa fa-share-alt" />
                                            </a>
                                            <ul>
                                                <li><a href="#"><i className="fa fa-facebook" /></a></li>
                                                <li><a href="#"><i className="fa fa-twitter" /></a></li>
                                                <li><a href="#"><i className="fa fa-pinterest" /></a></li>
                                                <li><a href="#"><i className="fa fa-linkedin" /></a></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="details">
                                    <h4><a href="#">Walson Jordan</a></h4>
                                    <span>UI/UX Expert</span>
                                </div>
                            </div>
                        </div> */}
                    </Slider>
                </div>
            </div>
            {/* team area end */}
            {/*blog-area start*/}
            <div className="blog-area pd-top-80 pd-bottom-90" id='blogs'>
                {
                    blogs && blogs.data && blogs.data.length > 0 && (
                        <div className="container">
                            <div className="row justify-content-center">
                                <div className="col-xl-6 col-lg-7">
                                    <div className="section-title text-center">
                                        <h6 className="sub-title double-line">{t('latestNewsHome')}</h6>
                                        <h2 className="title">{t('insightsAndArticleHome')}</h2>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-4">
                                    <ul className="single-blog-list-wrap mb-5 mb-lg-0">
                                        {
                                            blogs.data.map(blog => (
                                                <li key={blog?.id}>
                                                    <div className="media single-blog-list-inner">
                                                        <div className="media-left date">
                                                            <span>{moment(blog?.blog_date).utc().format('MMM')}</span>
                                                            {moment(blog?.blog_date).utc().format('DD')}
                                                        </div>
                                                        <div className="media-body details">
                                                            <ul className="blog-meta">
                                                                <li>
                                                                    <i className="fa fa-user" /> {t('byAdminHome')}
                                                                </li>
                                                                <li>
                                                                    <i className="fa fa-folder-open-o" /> {blog?.blog_category?.name}
                                                                </li>
                                                            </ul>
                                                            <h5>
                                                                <Link to={`/blog-details/${encodeURIComponent(encryption({ blog_id: blog.id }, true))}`}>
                                                                    {blog?.title}
                                                                </Link>
                                                            </h5>
                                                        </div>
                                                    </div>
                                                </li>
                                            ))
                                        }
                                    </ul>
                                </div>
                                <div className="col-lg-8">
                                    <div className="row justify-content-center">
                                        {
                                            blogs?.data.slice(0, 2).map(blog => (
                                                <div className="col-md-6" key={blog?.id}>
                                                    <div className="single-blog-inner">
                                                        <div className="thumb">
                                                            <Link to={`/blog-details/${encodeURIComponent(encryption({ blog_id: blog.id }, true))}`}>
                                                                <img src={blog?.image || process.env.PUBLIC_URL + "/assets/img/blog/1.png"} alt="img" />
                                                            </Link>
                                                            <span className="date">{moment(blog?.blog_date).utc().format('DD MMMM, YYYY').toUpperCase()}</span>
                                                        </div>
                                                        <div className="details">
                                                            <ul className="blog-meta">
                                                                <li>
                                                                    <i className="fa fa-user" /> {t('byAdminHome')}
                                                                </li>
                                                                <li>
                                                                    <i className="fa fa-folder-open-o" /> {blog?.blog_category?.name}
                                                                </li>
                                                            </ul>
                                                            <h5>
                                                                <Link to={`/blog-details/${encodeURIComponent(encryption({ blog_id: blog.id }, true))}`}>
                                                                    {blog?.title}
                                                                </Link>
                                                            </h5>
                                                            <Link to={`/blog-details/${encodeURIComponent(encryption({ blog_id: blog.id }, true))}`} className="read-more-text">
                                                                {t('readMoreHome')} <i className="fa fa-angle-right" />
                                                            </Link>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                }
            </div>
            {/*blog-area end*/}
            {/*contact-area start*/}
            <div
                className="contact-area bg-overlay mt-200 pd-bottom-90"
                style={{ backgroundImage: `url("${process.env.PUBLIC_URL}/assets/img/banner/2.png")` }}
                id='contact-us'
            >
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8">
                            <form className="contact-form-inner mt-mn-200 style-shadow" id="abc" onSubmit={handleSubmit(onSubmit)}>
                                <div className="section-title">
                                    <h2 className="title">{t('requestQuote')}</h2>
                                    <p>{t('answerQuestion')}</p>
                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="single-input-inner">
                                            <input type="text" placeholder={t('enterFieldName', { field: t("First_Name") })} name='first_name'
                                                {...register('first_name')}
                                            />
                                            <p className="text-danger">
                                                {errors.first_name?.message}
                                            </p>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="single-input-inner">
                                            <input type="text" placeholder={t('enterFieldName', { field: t("Last_Name") })} name='last_name'
                                                {...register('last_name')}
                                            />
                                            <p className="text-danger">
                                                {errors.last_name?.message}
                                            </p>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="single-input-inner">
                                            <input type="text" placeholder={t('enterFieldName', { field: t("Email") })} name='email'
                                                {...register('email')}
                                            />
                                            <p className="text-danger">
                                                {errors.email?.message}
                                            </p>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="single-input-inner">
                                            <input type="text" placeholder={t('enterFieldName', { field: t("Subject") })} name='subject'
                                                {...register('subject')}
                                            />
                                            <p className="text-danger">
                                                {errors.subject?.message}
                                            </p>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="single-input-inner">
                                            <textarea placeholder={t('enterFieldName', { field: t("Message") })} defaultValue={""} name='description'
                                                {...register('description')}
                                                style={{ resize: 'none' }}
                                            />
                                            <p className="text-danger">
                                                {errors.description?.message}
                                            </p>
                                        </div>
                                    </div>
                                    <div className="col-sm-6 align-self-center">
                                        <div className="single-input-inner style-checkbox">
                                            {/* <input type="checkbox" />
                                            {t('subscribeUs')} */}
                                        </div>
                                    </div>
                                    <div className="col-sm-6 text-sm-right">
                                        <button type='submit' className="btn btn-base">{t('sendMessage')}</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div className="col-lg-4 align-self-end">
                            <div className="mt-5 mt-lg-0">
                                <ul className="single-list-wrap">
                                    <li className="single-list-inner style-white style-check-box-grid-2">
                                        <div className="media">
                                            <div className="media-left">
                                                <img src={process.env.PUBLIC_URL + "/assets/img/icon/16.png"} alt="img" />
                                            </div>
                                            <div className="media-body align-self-center">
                                                <h5>{t('ourAddress')}</h5>
                                                <p>{t('address')}</p>
                                                <p>{t('address1')}</p>
                                            </div>
                                        </div>
                                    </li>
                                    <li className="single-list-inner style-white style-check-box-grid-2">
                                        <div className="media">
                                            <div className="media-left">
                                                <img src={process.env.PUBLIC_URL + "/assets/img/icon/17.png"} alt="img" />
                                            </div>
                                            <div className="media-body align-self-center">
                                                <h5>{t('ourPhone')}</h5>
                                                <p>{t('contactNo')}</p>
                                                {/* <p>+000 2324 39493</p> */}
                                            </div>
                                        </div>
                                    </li>
                                    <li className="single-list-inner style-white style-check-box-grid-2">
                                        <div className="media">
                                            <div className="media-left">
                                                <img src={process.env.PUBLIC_URL + "/assets/img/icon/18.png"} alt="img" />
                                            </div>
                                            <div className="media-body align-self-center">
                                                <h5>{t('ourEmail')}</h5>
                                                <p>{t('contactEmail')}</p>
                                                {/* <p>Info@orex.com</p> */}
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div >
            </div >
            {/*contact-area end*/}
            {/* FilterByOffcanvas  */}
            <div
                className="offcanvas offcanvas-start"
                tabIndex={-1}
                id="FilterByOffcanvas"
                aria-labelledby="FilterByOffcanvasLabel"
            >
                <div className="offcanvas-header">
                    <a href="home.php" className="HeaderLogoLink">
                        <img src={process.env.PUBLIC_URL + "/assets/img/logo-new.svg"} alt="img" />
                    </a>
                    <button
                        type="button"
                        className="btn btn-close"
                        data-bs-dismiss="offcanvas"
                        aria-label="Close"
                    />
                </div>
                <div className="offcanvas-body">
                    <ul className="FilterByOffcanvasUl">
                        <li className="FilterByOffcanvasLi">
                            <h4>{t('filterByHeading')}</h4>
                        </li>
                        <li className="FilterByOffcanvasLi">
                            <div className="SelectBox">
                                <Select name="category" id="category"
                                    placeholder={t('selectFieldName', { field: t('Category') })}
                                    value={
                                        selectedCategoryId
                                            ? { value: selectedCategoryId, label: categories.find(c => c.id === selectedCategoryId)?.name }
                                            : null
                                    }
                                    onChange={(data) => setSelectedCategoryId(data.value)}
                                    options={categories.map(category => ({ value: category.id, label: category.name }))}
                                    styles={reactSelectStyles}
                                />
                            </div>
                        </li>
                        <li className="FooterlinkLi">
                            <div className="FooterLinkBox">
                                <button
                                    className="btn btn-base b-animate-3"
                                    data-bs-dismiss="offcanvas"
                                    onClick={handleCloseFilter}
                                >
                                    {t('clear')}
                                </button>
                            </div>
                            <div className="FooterLinkBox">
                                <button
                                    className="btn btn-border-black b-animate-3"
                                    data-bs-dismiss="offcanvas"
                                    onClick={handleApplyFilter}
                                >
                                    {t('apply')}
                                </button>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div
                className="offcanvas offcanvas-start"
                tabIndex={-1}
                id="sorting_canvas"
                aria-labelledby="sorting_canvas"
            >
                <div className="offcanvas-header">
                    <a href="home.php" className="HeaderLogoLink">
                        <img src={process.env.PUBLIC_URL + "/assets/img/logo-new.svg"} alt="img" />
                    </a>
                    <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="offcanvas"
                        aria-label="Close"
                    />
                </div>
                <div className="offcanvas-body">
                    {/* <form> */}
                    <ul className="FilterByOffcanvasUl">
                        <li className="FilterByOffcanvasLi">
                            <h4>{t('sortByHeading')}</h4>
                        </li>
                        <li className='d-flex justify-content-between'>
                            <h5>{t('latest')}</h5>
                            <input type='checkbox' id="sortby-latest-inp" />
                        </li>
                        <li className="FilterByOffcanvasPriceLi">
                            <h5>{t('priceRange')}</h5>
                            <div slider="" id="slider-distance">
                                <div>
                                    <div inverse-left="" style={{ width: `${(range1 / maxRange) * 100}%` }} />
                                    <div inverse-right="" style={{ width: `${100 - (range2 / maxRange) * 100}%` }} />
                                    <div range="" style={{ left: `${(range1 / maxRange) * 100}%`, right: `${100 - (range2 / maxRange) * 100}%` }} />
                                    <span thumb="" style={{ left: `${(range1 / maxRange) * 100}%` }} />
                                    <span thumb="" style={{ left: `${(range2 / maxRange) * 100}%` }} />
                                    <div sign="" style={{ left: `${(range1 / maxRange) * 100}%` }}>
                                        <span id="value">₹{range1}</span>
                                    </div>
                                    <div sign="" style={{ left: `${(range2 / maxRange) * 100}%` }}>
                                        <span id="value">₹{range2}</span>
                                    </div>
                                </div>
                                <input
                                    type="range"
                                    tabIndex={0}
                                    value={range1}
                                    max={maxRange}
                                    min={minRange}
                                    step={1}
                                    onChange={handleRange1Input}
                                />
                                <input
                                    type="range"
                                    tabIndex={0}
                                    value={range2}
                                    max={maxRange}
                                    min={minRange}
                                    step={1}
                                    onChange={handleRange2Input}
                                />
                            </div>
                        </li>

                        <li className="FilterByOffcanvasReviewLi">
                            <h5>{t('reviewRange')}</h5>
                            <ul className="RatingUl">
                                {[...Array(5)].map((_, index) => (
                                    <li
                                        key={index}
                                        className="RatingLi"
                                        onMouseLeave={handleMouseLeave}
                                        onMouseMove={(e) => handleMouseMove(index, e)}
                                        onClick={(e) => handleRatingClick(index, e.nativeEvent.offsetX < e.target.clientWidth / 2)}
                                        style={{
                                            cursor: 'pointer',
                                            display: 'inline-block',
                                            position: 'relative',
                                        }}
                                    >
                                        <img
                                            src={renderStarIcon(index)}
                                            className="img-cover"
                                            alt="Star"
                                        />
                                    </li>
                                ))}
                            </ul>
                        </li>

                        <li className="FooterlinkLi">
                            <div className="FooterLinkBox">
                                <button
                                    className="btn btn-base b-animate-3"
                                    data-bs-dismiss="offcanvas"
                                    onClick={handleCloseSortBy}
                                >
                                    {t('clear')}
                                </button>
                            </div>
                            <div className="FooterLinkBox">
                                <button
                                    className="btn btn-border-black b-animate-3"
                                    data-bs-dismiss="offcanvas"
                                    onClick={handleApplySortBy}
                                >
                                    {t('apply')}
                                </button>
                            </div>
                        </li>
                    </ul>
                    {/* </form> */}
                </div>
            </div>
        </>
    )
}

export default Home;